export default __webpack_public_path__ + "static/media/alfaromeo-tonale.abdef297.png";